import { render } from "./BeatsListFilters.vue?vue&type=template&id=5ec775a6"
import script from "./BeatsListFilters.vue?vue&type=script&lang=js"
export * from "./BeatsListFilters.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__